export default "__VITE_ASSET__CWi9InJ1__"